/* RESPONSIBLE TEAM: team-inbox */
import type AppService from 'embercom/services/app-service';
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';
import ConversationAttributeDescriptor from 'embercom/models/conversation-attributes/descriptor';
import type Store from '@ember-data/store';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import { type Router } from '@ember/routing';
import { taskFor } from 'ember-concurrency-ts';
import type Transition from '@ember/routing/-private/transition';
import type CopilotUsageService from 'embercom/services/copilot-usage-service';
import type CustomReportsService from 'embercom/services/custom-reports-service';

export default class CopilotRoute extends IntercomRoute {
  @service declare appService: AppService;
  @service declare store: Store;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare router: Router;
  @service declare copilotUsageService: CopilotUsageService;
  @service declare intercomEventService: $TSFixMe;
  @service declare customReportsService: CustomReportsService;

  analytics = { place: 'copilot' };
  reportName = 'fin_copilot_report';
  reportContext = 'fin';

  activate() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'viewed',
      object: this.reportName,
      context: this.reportContext,
    });
  }

  beforeModel() {
    if (this.appService.app.cannotSeeDeprecatedReports) {
      this.customReportsService.routeToOverviewPage();
    }
  }

  async model(_params: any, _transition: Transition) {
    let settings = this._fetchReportingSetting();
    let conversationAttributeDescriptors = ConversationAttributeDescriptor.peekAllAndMaybeLoad();
    let metricsSetup = taskFor(this.reportingMetrics.setup).perform();

    await this.copilotUsageService.refreshCopilotUsageData();

    let showRoiCalculatorArticle = () => {
      window.Intercom('showArticle', 9447924);
    };

    return hash({
      settings,
      conversationAttributeDescriptors,
      metricsSetup,
      showRoiCalculatorArticle,
    });
  }

  _fetchReportingSetting() {
    return (
      this.store.peekAll('reporting/settings')?.firstObject ||
      this.store.queryRecord('reporting/settings', {})
    );
  }
}
